<template>
  <div>
    <div class="dldeing">设 置 密 保</div>
    <div class="pin">
      <van-cell
        :title="text"
        is-link
        arrow-direction="down"
        @click="show = true"
      />
      <van-field v-model="wen" placeholder="请输入答案！" />
      <van-cell
        :title="text1"
        is-link
        arrow-direction="down"
        @click="show1 = true"
      />
      <van-field v-model="wen1" placeholder="请输入答案！" />
      <div class="dlanniu" @click="dian">确 认</div>
    </div>
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-cell-group>
        <van-cell
          :title="list.name"
          v-for="(list, index) in data"
          :key="index"
          :class="value == list.code ? 'huangsede' : ''"
          @click="xuan(list)"
        />
      </van-cell-group>
    </van-popup>
    <van-popup
      v-model="show1"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-cell-group>
        <van-cell
          :title="list.name"
          v-for="(list, index) in data"
          :key="index"
          :class="value1 == list.code ? 'huangsede' : ''"
          @click="xuan1(list)"
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>
<script>
import { userquestions,userquestionspost } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      value: "",
      value1: "",
      text: "",
      text1: "",
      show: false,
      show1: false,
      data: [],
      wen: "",
      wen1: "",
    };
  },
  watch: {},
  components: {},
  methods: {
    index() {
      let that = this;
      userquestions()
        .then((res) => {
          that.data = res.data.data;
          that.text = "1、" + res.data.data[0].name;
          that.text1 = "2、" + res.data.data[1].name;
          that.value = res.data.data[0].code;
          that.value1 = res.data.data[1].code;
        })
        .catch((rdd) => {});
    },
    xuan(s) {
      if (s.code == this.value1) {
        Toast("请勿重复选择密保问题!");
        return false;
      }
      this.value = s.code;
      this.text = "1、" + s.name;
      this.show = false;
    },
    xuan1(s) {
      if (s.code == this.value) {
        Toast("请勿重复选择密保问题!");
        return false;
      }
      this.value1 = s.code;
      this.text1 = "2、" + s.name;
      this.show1 = false;
    },
    dian() {
      let that = this;
      // //console.log(this.data.code)
      // return false;
      if (this.data.value == "" || this.data.value1 == "") {
        Toast("请填写密保问题");
        return false;
      }
      let params = {
        roleType: "teacher",
        userId:localStorage.getItem("userId"),
        useranswerList: [
          { answer: this.wen, questionCode: this.value },
          { answer: this.wen1, questionCode: this.value1 },
        ],
      };
      userquestionspost(params)
        .then((res) => {
            Toast("设置成功,忘记密码时使用！");
            setTimeout(function () {
              that.$router.push({
              path: "/index",
            });
            }, 1000);
        })
        .catch((rdd) => {});
    },
  },
  mounted() {
    this.index();
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/security.vue